<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Markering beheren</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/decorations">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-6">
            <form [formGroup]="form()">
                <mat-form-field class="w-100" id="name">
                    <input formControlName="name" matInput name="name" placeholder="Naam" type="text">
                    <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
                </mat-form-field>
                <mat-form-field class="w-100">
                    <mat-label>Oppervlakte</mat-label>
                    <input formControlName="surface" matInput placeholder="Oppervlakte in m²" step="0.001" type="number">
                    <mat-error>Vul een oppervlakte in m² in</mat-error>
                </mat-form-field>
                <mat-checkbox formControlName="specify_length" name="specify_length">Lengte specificeren</mat-checkbox>
                <br>
                <mat-checkbox formControlName="specific_price" name="specify_length">Specifieke prijs</mat-checkbox>
                <br>
                <mat-checkbox formControlName="priority_figuration" name="priority_figuration">Voorrangsfiguratie</mat-checkbox>
                <br>
                <mat-checkbox formControlName="mold" name="mold">Mal aanvragen mogelijk</mat-checkbox>
                @if (types) {
                    <ng-select
                        [closeOnSelect]="true"
                        [items]="types"
                        [multiple]="false"
                        formControlName="type"
                        id="type"
                        name="type"
                        placeholder="Type">
                    </ng-select>
                }
                @if (groups()) {
                    <ng-select
                        [addTag]="true"
                        [closeOnSelect]="true"
                        [items]="groups()"
                        [multiple]="false"
                        formControlName="decoration_group"
                        id="customerareas"
                        name="decoration_group"
                        placeholder="Groep">
                    </ng-select>
                }
            </form>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-6 col-12">
            <div class="d-flex">
                <button mat-button routerLink="/decorations">Terug</button>
                <div class="spacer"></div>
                <button (click)="save()" [disabled]="form().invalid" color="primary" id="btn-save" mat-raised-button>
                    Opslaan
                </button>
            </div>
        </div>
    </div>
</div>
